export const sortFilterChipsByLabelOrder = <T>(
  entries: [string, T][],
  labels: { [key: string]: string },
): [string, T][] => {
  const labelsKeys = Object.keys(labels);
  return entries.sort((a, b) => {
    const indexA = labelsKeys.indexOf(a[0]);
    const indexB = labelsKeys.indexOf(b[0]);
    return indexA - indexB;
  });
};
